import React, { CSSProperties, useEffect, useMemo, useState } from "react"
import { colors, css, fonts } from "../../../Styles";
import { useTranslation } from "react-i18next";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";

interface EsfStationAttention_Props{
  station?: EsfLocation;
  borderRadius?: CSSProperties;
}

export function EsfStationAttention({ station, borderRadius }: EsfStationAttention_Props) {
  const { t } = useTranslation()
  const [animate, setAnimate] = useState(false);
 
  useEffect(() => {
    setAnimate(true);
  }, []);
  
  return (
    <div
      style={{
        height: "30px",
        width: "170px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          overflow: "hidden",
          position: "relative",
          width: "100%",
          height: "100%",
          textAlign: "center",
          alignContent: "center",
          boxSizing: "border-box",
          padding: "0px 10px",
          backgroundColor: colors.greyLightSecondary,
          color: colors.greyDarkPrimary,
          ...fonts.paragraph,
          ...fonts.fontSize4,
          ...borderRadius,
        }}
      >
        {`Station ${station?.name}`}
        <div style={{ top: "0", left: "0", position: "absolute", width: animate ? "10px" : "0px", height: "30px", backgroundColor: colors.systemRed, transition: "width 0.5s ease" }}></div>
        {/* {hasAttention && TerminalDatas.map((data, index) => (
          data?.TerminalData?.fk_locations === pen.location_id && (
            <div key={index} style={{ top: "0", left: "0", position: "absolute", width: animate ? "10px" : "0px", height: "30px", backgroundColor: data.attentionColor, transition: "width 0.5s ease" }}></div>
          )
        ))} */}
      </div>
    </div>
  );
}

interface EsfSectionAttention_Props {
  stations: EsfLocation[]
  sectionId: number;
}

export function EsfSectionAttention({ stations, sectionId }: EsfSectionAttention_Props) {
  const {t} = useTranslation()

  // Error throwback if there are no pens
  if (stations.length === 0) {
    return <p style={{...css.paragraph, ...css.fontSize4, color: colors.greyDarkPrimary}}>{t("noData", {defaultValue:"no data"})}</p>;
  }

  const numRows = Math.ceil(stations.length / 1);
  const section = stations.map((station, index) => {
    const rowIndex = Math.floor(index / 1);

    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === numRows - 1;

    let borderRadius = "0px";

    if (isFirstRow) borderRadius = "10px 10px 0px 0px";
    if (isLastRow) borderRadius = "0px 0px 10px 10px";

    return ( 
      <EsfStationAttention
        key={station.location_id}
        station={station}
        borderRadius={{ borderRadius }}
      />
    )   
  })
  
  return (
    <div style={{ width: "fit-content", height: "fit-content", gap: "10px", borderRadius: "10px" }}>
       <div style={{ display: "grid", gridTemplateColumns: "1fr", width: "fit-content", gap: "10px", borderRadius: "10px" }}>
          {section}
        </div>
    </div>
  )
}